<template>
  <d-col md="4" lg="3" class="mb-4">
    <d-btn class="d-md-none" outline block-level theme="primary" v-d-toggle.searchFilters @click='toggleResponsiveFilters = !toggleResponsiveFilters'>
      <div v-show='!toggleResponsiveFilters'>
        <i class="material-icons">filter_alt</i> Show filters
      </div>
      <div v-show='toggleResponsiveFilters'>
        <i class="material-icons">expand_less</i> Hide filters
      </div>
    </d-btn>
    <d-collapse id="searchFilters" class="d-md-none mt-3 mt-md-0">
      <component v-for="(item, idx) in searchSettings.facets" :key="idx" v-bind="item" :is="item.is || 'facet'" />
    </d-collapse>


    <!-- <button class="btn btn-outline-primary btn-block d-md-none" type="button" data-toggle="collapse" data-target="#searchFilters" aria-expanded="false" aria-controls="searchFilters">
      <i class="material-icons">filter_alt</i> Show filters
    </button>
    <div class="collapse" id="searchFilters">

    </div> -->


  </d-col>
</template>
<script>
// import
import { mapState } from 'vuex';
import { createWidgetMixin } from 'vue-instantsearch';
import Facet from '@/components/search/Facet.vue';
import NumericFacet from '@/components/search/NumericFacet.vue';

export default {
  mixins: [createWidgetMixin({ connector: true })],
  computed: {
    ...mapState(['searchSettings']),
  },
  watch: {
    showFilters(newValue) {
      if (!newValue) {
        this.instantSearchInstance.helper.clearRefinements().search();
      }
    },
  },
  components: {
    Facet,
    NumericFacet,
  },
  data() {
    return {
      toggleResponsiveFilters: false,
      algoliaFacetFilters: this.$route.meta.filters || [],
    };
  },
  mounted() {
    //
  },
};
</script>
